// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    headingBlack: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    mainButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Main Button Text",
        translatable: true
    },
    secondaryButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Secondary Button Text",
        translatable: true
    }
};
